import Vue from "vue";

export const UserState = {
  currentUser: {
    id: 0,
    name: "",
    email: "",
    role: "",
    status: "",
    is_owner: false,
    restriction_type: "",
    user_tags: [],
    can_deactivate: false,
    upcoming_todos: [],
    parent_form_id: "",
    sign_in_token: ""
  },
  //
  user: null,
  users: [],
  totalUsers: 0,
  sessionHistories: []
};

export const UserGetters = {
  currentUser: state => {
    return state.currentUser;
  },
  //
  user: state => {
    return state.user;
  },
  users: state => {
    return state.users;
  },
  totalUsers: state => {
    return state.totalUsers;
  },
  sessionHistories: state => {
    return state.sessionHistories;
  }
};

export const UserMutations = {
  setCurrentUser: (state, data) => {
    let currentUser = data || { id: 0 };
    if (data) {
      const arr = data.upcoming_todos.map(i => ({
        ...i,
        documents: i.documents || []
      }));
      currentUser = { ...data, upcoming_todos: arr };

      const index = state.users.findIndex(
        i => Number(i.id) === Number(currentUser.id)
      );
      if (index > -1) {
        const arr = [...state.users];
        arr[index] = currentUser;
        Vue.set(state, "users", arr);
      }

      if (state.user && Number(currentUser.id) === Number(state.user.id)) {
        Vue.set(state, "user", currentUser);
      }
    }
    Vue.set(state, "currentUser", currentUser);
  },
  //
  setUser: (state, data) => {
    if (data) {
      const index = state.users.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.users];
        arr[index] = data;
        Vue.set(state, "users", arr);
      }
    }
    Vue.set(state, "user", data);
  },
  setUsers: (state, data) => {
    Vue.set(state, "users", data.users);
    Vue.set(state, "totalUsers", data.total_users);
  },
  addUser: (state, data) => {
    Vue.set(state, "users", [data, ...state.users]);
    Vue.set(state, "totalUsers", state.totalUsers + 1);
  },
  removeUser: (state, data) => {
    const arr = state.users.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "users", arr);
    Vue.set(state, "totalUsers", state.totalUsers - 1);
  },
  setSessionHistories: (state, data) => {
    const result = [];
    for (const key in data) {
      result.push({
        date: key,
        number_of_session: data[key].length,
        sessions: data[key]
      });
    }
    Vue.set(state, "sessionHistories", result);
  }
};

export const UserActions = {
  getCurrentUser: ({ commit, dispatch }) => {
    return Vue.axios.secured
      .get(`/api/v1/current_user`)
      .then(async response => {
        commit("setCurrentUser", response.data);
        await dispatch("getCurrentCenter");
        return { success: true, data: response.data };
      })
      .catch(error => {
        // const err = error.response && error.response.data;
        // const message = err || "Unable to fetch current user from server.";
        console.error(error);
        const message = "You have signed out";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  checkCurrentUser: ({ commit }) => {
    // for re-fetch or re-load
    return Vue.axios.secured
      .get(`/api/v1/current_user`)
      .then(response => {
        commit("setCurrentUser", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error);
        return { success: false, data: null };
      });
  },
  createCurrentUser: ({ commit }, data = {}) => {
    commit("setCurrentUser", data);
    return { success: true, data };
  },
  updateCurrentUser: ({ state, commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/users/${state.currentUser.id}`, { user: data.user })
      .then(response => {
        commit("setCurrentUser", response.data.user);
        const title = data.title || "Account updated";
        const message =
          data.message || "Success! Your account has been updated.";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update account.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  verifyCurrentUserPassword: ({ state, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/users/${state.currentUser.id}/verify_password`, {
        password: data.password
      })
      .then(response => {
        if (response.data.error) {
          const message = response.data.error;
          dispatch("showToast", { message, type: "error" });
          return { success: false, data: null, message };
        }
        return { success: true, data: response.data, message: "" };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to verify password.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null, message };
      });
  },
  moveCurrentUserCenter: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/current_user/move_to_center/${data.center_id}`)
      .then(async response => {
        commit("setCurrentUser", response.data);
        await dispatch("getCurrentCenter");
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update account.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getUsers: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    const search = data.search || false;
    return Vue.axios.secured
      .get(`/api/v1/users${params}`)
      .then(response => {
        if (search) return { success: true, data: response.data.users };
        commit("setUsers", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch users from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getUser: ({ commit, dispatch }, data = {}) => {
    if (!data.id) {
      commit("setUser", null);
      return { success: false, data: null };
    }
    return Vue.axios.secured
      .get(`/api/v1/users/${data.id}`)
      .then(response => {
        commit("setUser", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch user from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/users", { user: data.user })
      .then(response => {
        commit("addUser", { ...response.data.user, is_new: true });
        const title = "New member created";
        const message = "Success! New member has been created successfully.";
        dispatch("showToast", { title, message, type: "success" });
        dispatch("getCurrentCenter");
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to add user.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  checkUserEmail: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/users/check_email", { email: data.email })
      .then(response => {
        return {
          available: response.data.available,
          message: response.data.message
        };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable check user email.";
        dispatch("showToast", { message, type: "error" });
        return { available: false, message };
      });
  },
  downloadUserDetails: ({ context }, data) => {
    return Vue.axios.secured
      .get(`/api/v1/users/download_details${data}`, { responseType: "blob" })
      .then(response => {
        return { success: true, response };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable download user details.";
        console.error(message);
        return { success: false, response: null };
      });
  },
  updateUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/users/${data.id}`, { user: data.user })
      .then(response => {
        commit("setUser", response.data.user);
        const title = data.title || "User updated";
        const message = data.message || "Success! The user has been updated";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update user.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateUserPassword: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/users/${data.id}`, { user: data.user })
      .then(response => {
        const title = "Password reset";
        const message = "Success! The password has been reset successfully.";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update user password.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  reactivateUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/users/${data.id}/reactivate`)
      .then(response => {
        commit("setUser", data.user);
        const title = "Member activated";
        const message = "Success! The member has been successfully activated.";
        dispatch("showToast", { title, message, type: "success" });
        dispatch("getCurrentCenter");
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to activated user.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deactivateUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/users/${data.id}/deactivate`)
      .then(response => {
        commit("setUser", data.user);
        const title = "Member deactivated";
        const message =
          "Success! The member has been successfully deactivated from Blüm.";
        dispatch("showToast", { title, message, type: "success" });
        dispatch("getCurrentCenter");
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to deactivated user.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/users/${data.id}`)
      .then(() => {
        commit("removeUser", data);
        const title = "Member removed";
        const message = "Success! Member successfully removed from Blüm.";
        dispatch("showToast", { title, message, type: "success" });
        dispatch("getCurrentCenter");
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete user.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  getUserSessionHistories: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/users/${data.id}/sessions${params}`)
      .then(response => {
        commit("setSessionHistories", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch session history from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  checkUserAppointments: ({ dispatch }, data = {}) => {
    const params = "?status=scheduled,in_progress";
    return Vue.axios.secured
      .get(`/api/v1/users/${data.id}/check_appointments${params}`)
      .then(response => {
        const res = [];
        if (response.data) {
          for (let key in response.data) {
            if (response.data.hasOwnProperty(key)) {
              const temp = response.data[key];
              res.push({ date: key, appointments: temp });
            }
          }
        }
        return { success: true, data: res };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch user appointment from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: [] };
      });
  },
  inviteManualBulkUser: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(
        "/api/v1/users/invite_bulk",
        { center_id: data.center_id, invite_type: "manual", users: data.users },
        { responseType: "blob" }
      )
      .then(response => {
        const count = data.users.length;
        const title = `${count} new member(s) created`;
        const message = `Success! ${count} new member(s) has been created.`;
        dispatch("showToast", { title, message, type: "success" });
        dispatch("getCenter", { id: data.center_id });
        return { success: true, response };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        // const message = err || "Unable to invite bulk user.";
        // dispatch("showToast", { message, type: "error" });
        return { success: false, response: err.error };
      });
  },
  inviteCSVBulkUser: ({ dispatch }, data = {}) => {
    // {
    //   "center_id": 1,
    //   "invite_type": "csv",
    //   "file": file.csv
    // }
    return Vue.axios.secured
      .post("/api/v1/users/invite_bulk", data)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        // const message = err || "Unable to invite bulk user.";
        // dispatch("showToast", { message, type: "error" });
        return { success: false, data: err.error };
      });
  },
  checkCSVBulkUser: ({ context }, data = {}) => {
    // {
    //   "center_id": 1,
    //   "file": file.csv
    // }
    return Vue.axios.secured
      .post("/api/v1/users/check_data_users", data)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        // const message = err || "Unable to check csv invite bulk user.";
        // dispatch("showToast", { message, type: "error" });
        return { success: false, data: err.error };
      });
  },
  // GET /api/v1/create_user_queues/:job_id
  checkInviteUserJob: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/create_user_queues/${data.id}`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to check user job from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  // PATCH /api/v1/create_user_queues/:job_id/cancel
  cancelInviteUserJob: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/create_user_queues/${data.id}/cancel`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = (err && err.error) || "Unable to cancel user job.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  // GET /api/v1/create_user_queues/:job_id/download_user_details
  downloadInviteUserJobDetails: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/create_user_queues/${data.id}/download_user_details`, {
        responseType: "blob"
      })
      .then(response => {
        return { success: true, response };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message =
          (err && err.error) || "Unable to check user job from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, response: null };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.store.js